module.exports = __webpack_public_path__ + "img/dsg.25811ed8.png";